import React from "react";
import { Box, Typography, ToggleButton, ToggleButtonGroup } from "@mui/material";

import DashboardFilters from "./DashboardFilters";
import { CARD_TEXT, CARD_BORDER, TOGGLE_TRACK_BG } from "./cardTokens";
import { STATUS_VIEW, TYPE_VIEW } from "./homeFilters";

// Single "Dashboard" title + By status/By type toggle + Notice date/Transaction
// type/Transaction manager filter row, shared above both the Pre-transaction and
// Transaction sections (per Figma) - as opposed to each section carrying its own
// duplicate toggle and filters.
const DashboardHeader = ({ value, onChange }) => {
  const view = value.view || STATUS_VIEW;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        width: "100%",
        flexWrap: "wrap",
        gap: "16px",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "24px" }}>
        <Typography
          sx={{ fontSize: "24px", lineHeight: "32px", letterSpacing: "-0.06px", color: CARD_TEXT }}
        >
          Dashboard
        </Typography>
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={(event, newView) => newView && onChange({ ...value, view: newView })}
          sx={{
            backgroundColor: TOGGLE_TRACK_BG,
            borderRadius: "8px",
            height: "44px",
            boxSizing: "border-box",
            display: "flex",
            alignItems: "center",
            padding: "4px",
            "& .MuiToggleButtonGroup-grouped": {
              border: "none",
              margin: 0,
            },
            "& .MuiToggleButton-root": {
              height: "36px",
              boxSizing: "border-box",
              borderRadius: "6px",
              textTransform: "none",
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "24px",
              letterSpacing: "-0.04px",
              color: "#56656b",
              px: "12px",
              py: 0,
              "&.Mui-selected": {
                backgroundColor: "#fff",
                color: CARD_TEXT,
                fontWeight: 400,
                border: `1px solid ${CARD_BORDER}`,
                boxShadow: "0px 1px 1.5px rgba(75, 91, 97, 0.12)",
              },
            },
          }}
        >
          <ToggleButton value={STATUS_VIEW}>By status</ToggleButton>
          <ToggleButton value={TYPE_VIEW}>By type</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <DashboardFilters view={view} value={value} onChange={onChange} />
    </Box>
  );
};

export default DashboardHeader;
